namespace Gamification.Gamification {
    export enum ApiScriptUtenteMostraBadgeEnum {
        Badge_Tutti = 1,
        Badge_Ottenuti = 2,
        Badge_Non_Ottenuti = 3
    }
    Serenity.Decorators.registerEnumType(ApiScriptUtenteMostraBadgeEnum, 'Gamification.Gamification.ApiScriptUtenteMostraBadgeEnum');
}
